import { Component, OnInit } from '@angular/core';
import { ElementRef } from '@angular/core';

@Component({
  selector: 'app-casestudy',
  templateUrl: './casestudy.component.html',
  styleUrls: ['./casestudy.component.css']
})
export class CasestudyComponent implements OnInit {

  constructor(private elementRef:ElementRef) {
       
  }

  ngOnInit() {
  }
  sendEvent = (type: string, cat: string) => {
    (<any>window).ga('send', 'event', {
      eventCategory: cat,
      eventLabel: 'Casestudy',
      eventAction: type,
      eventValue: 10
    });
  }

}



// WEBPACK FOOTER //
// /Users/jacobvarghese/git/matchiq-web/matchiq/src/app/casestudy/casestudy.component.ts